import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { TransitionGroup } from 'react-transition-group';
import TransitionContainer from '../../components/Transition/TranstionContainer';
import CssTransition from '../../components/Transition/CssTransition';

import ErrorPopup from '../../components/VoteRegistration/ErrorPopup';

import VoteRegistrationStep8Form from '../../components/VoteRegistration/VoteRegistrationStep8Form';

import { getActionCompletedTime } from '../../utils/actionTiming';
import { CardTypes, RacesList, AddressSource } from '../../utils/enums';
import { cacheFormData } from '../../utils/formCaching/actions';
import { onGoToStep, saveForm } from './actions';
import {
    widgetBounce,
    setExitingCardProps,
    getExitingCardProps
} from '../Widget/actions';

import {
    ContainerStyled,
    LegalInfoWrapper,
    FormWrapper
} from '../DefaultStyles/AssessmentDetails';

import VoteRegistrationSidebar from '../../components/VoteRegistration/VoteRegistrationSidebar';

import LegalInfo from '../../components/Widget/LegalInfo';

const VoteRegistrationStep8 = props => (
    <TransitionContainer
        isSubmitting={props.isFormSubmitting}
        isBackTransition={props.isBackTransition}
        zIndex={32}
    >
        <ContainerStyled>
            <VoteRegistrationSidebar loadRep={true} title={'Voter Registration'} />
            <FormWrapper>
                <VoteRegistrationStep8Form
                    onBack={() => {
                        if (!props.bounceDismissed) {
                            props.widgetBounce(
                                true,
                                props.widgetRequestId,
                                props.articleUrl,
                                props.currentFormValues,
                                props.actionIdentifier
                            );
                        } else {
                            props.setExitingCardProps(
                                'voteRegistration',
                                props,
                                props.activeAction
                            );
                            props.onGoToStep(
                                7,
                                'back',
                                null,
                                null,
                                [4, 5, 6, 7],
                                props.formData
                            );
                        }
                    }}
                    onSubmit={values => {
                        props.cacheFormData(values);
                        props.setExitingCardProps(
                            'voteRegistration',
                            props,
                            props.activeAction
                        );
                        props.saveForm(
                            values,
                            [],
                            props.apiRequestData,
                            props.formData,
                            props.id,
                            props.answerId,
                            AddressSource.addressSource,
                            true,
                            props.actionIdentifier,
                            props.isMultiActionsCard,
                            props.actionCompletedTime()
                        );
                    }}
                    infoTextRace={props.infoTextRace}
                    infoTextRaceRequired={props.infoTextRaceRequired}
                    infoTextParty={props.infoTextParty}
                    infoTextPartyRequired={props.infoTextPartyRequired}
                    parties={props.parties}
                    races={props.races}
                    isFormSubmitting={props.isFormSubmitting}
                />
                {props.isMobileResolution && (
                    <LegalInfoWrapper>
                        <LegalInfo />
                    </LegalInfoWrapper>
                )}
            </FormWrapper>
            <TransitionGroup>
                {props.showErrorPopup && (
                    <CssTransition key="alert" in={props.showErrorPopup}>
                        <ErrorPopup />
                    </CssTransition>
                )}
            </TransitionGroup>
        </ContainerStyled>
    </TransitionContainer>
);

VoteRegistrationStep8.propTypes = {
    activeAction: PropTypes.object.isRequired,
    onGoToStep: PropTypes.func.isRequired,
    saveForm: PropTypes.func.isRequired,
    formData: PropTypes.object,
    infoTextRace: PropTypes.string,
    infoTextRaceRequired: PropTypes.bool,
    infoTextParty: PropTypes.string,
    infoTextPartyRequired: PropTypes.bool,
    parties: PropTypes.array,
    races: PropTypes.array,
    apiRequestData: PropTypes.object.isRequired,
    id: PropTypes.number,
    answerId: PropTypes.number,
    isFormSubmitting: PropTypes.bool,
    isBackTransition: PropTypes.bool,
    isMobileResolution: PropTypes.bool,
    actionIdentifier: PropTypes.string.isRequired,
    isMultiActionsCard: PropTypes.bool.isRequired,
    showErrorPopup: PropTypes.bool,
    actionCompletedTime: PropTypes.func.isRequired,
    cacheFormData: PropTypes.func.isRequired,
    setExitingCardProps: PropTypes.func.isRequired,
    bounceDismissed: PropTypes.bool.isRequired,
    currentFormValues: PropTypes.object.isRequired,
    articleUrl: PropTypes.string.isRequired,
    widgetRequestId: PropTypes.string.isRequired,
    widgetBounce: PropTypes.func.isRequired
};

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'voteRegistration',
            ['/voteRegistration/step8'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        return {
            formData: state.voteRegistration.formData,
            infoTextRace: state.voteRegistration.completeVoteRegistration.requiresRaceMsg,
            infoTextRaceRequired:
                state.voteRegistration.completeVoteRegistration.requiresRace,
            infoTextParty:
                state.voteRegistration.completeVoteRegistration.requiresPartyMsg,
            infoTextPartyRequired:
                state.voteRegistration.completeVoteRegistration.requiresParty,
            parties: state.voteRegistration.completeVoteRegistration.partyList,
            races: RacesList,
            apiRequestData: state.widget.apiRequestData,
            id: state.widget.activeAction.id,
            answerId:
                state.voteRegistration.completeVoteRegistration.voteRegistrationAnswerId,
            isFormSubmitting: state.voteRegistration.isFormSubmitting,
            isBackTransition: state.voteRegistration.isBackTransition,
            isMobileResolution: state.widget.isMobileResolution,
            actionIdentifier: state.widget.activeAction.identifier,
            isMultiActionsCard:
                state.widget.cards[state.widget.activeAction.order - 1].type ===
                CardTypes.multipleActions,
            showErrorPopup: state.voteRegistration.errorInfo
                ? state.voteRegistration.errorInfo.showErrorPopup
                : false,
            actionCompletedTime: getActionCompletedTime(state, 'voteRegistration'),
            bounceDismissed: state.widget.bounceDismissed,
            widgetRequestId: state.widget.widgetRequestId,
            articleUrl: state.widget.articleUrl,
            currentFormValues: (state.form['voteRegistrationStep8Form'] || {}).values
        };
    },
    { widgetBounce, onGoToStep, saveForm, cacheFormData, setExitingCardProps }
)(VoteRegistrationStep8);
